import { useQuery } from 'react-query';

import { api } from '../main-request/base';

const useFileApi = (url, params, options) => {
	return useQuery([url, params], async () => api.get(url, { params, responseType: 'blob' }), { enabled: false });
};

export default useFileApi;
